export default __webpack_public_path__ + "static/media/chat-thumbnail.a5568b80.jpg";